/**
 * Table -> card conversion inside Fees & Charges accordions.
 * Matrix may sanitize inline <script>, so this lives in the module JS bundle.
 */
(function () {
    'use strict';

    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function isMobile() {
        return mobileQuery.matches;
    }

    function normalizeLabel(str) {
        return (str || '').replace(/\s+/g, ' ').trim();
    }

    function cleanHeaderLabel(str) {
        var s = normalizeLabel(str);
        // Remove leading year range like "2025/ 26 "
        s = s.replace(/^\d{4}\s*\/\s*\d{1,2}\s+/g, '');
        return normalizeLabel(s);
    }

    function getResponsiveWrapper(table) {
        return (
            table.closest(
                '.table-responsive, .table-responsive-sm, .table-responsive-md, .table-responsive-lg, .table-responsive-xl'
            ) || table.parentNode
        );
    }

    function ensureId(el) {
        if (el.id) return el.id;
        el.id = 'accordionTable_' + Math.random().toString(36).slice(2);
        return el.id;
    }

    function findCardsContainer(root, tableId) {
        var all = root.querySelectorAll('.accordion-table-cards');
        for (var i = 0; i < all.length; i++) {
            var el = all[i];
            if (el && el.dataset && el.dataset.tableId === tableId) return el;
        }
        return null;
    }

    function buildCardsForTable(root, table) {
        if (table.dataset.tableCardsBuilt === 'true') return;

        var theadTh = table.querySelectorAll('thead th');
        var tbodyRows = table.querySelectorAll('tbody tr');
        if (!theadTh.length || !tbodyRows.length) return;

        var headers = Array.prototype.map.call(theadTh, function (th) {
            return normalizeLabel(th.textContent);
        });
        if (!headers.length) return;

        var wrapper = getResponsiveWrapper(table);
        if (!wrapper || !wrapper.parentNode) return;

        var tableId = ensureId(table);

        var cardsContainer = document.createElement('div');
        cardsContainer.className = 'accordion-table-cards';
        cardsContainer.dataset.tableId = tableId;
        cardsContainer.style.display = 'none';

        Array.prototype.forEach.call(tbodyRows, function (tr) {
            var cellEls = Array.prototype.slice.call(tr.querySelectorAll('td'));
            if (!cellEls.length) return;

            var values = cellEls.map(function (td) {
                return normalizeLabel(td.textContent);
            });

            var card = document.createElement('div');
            card.className = 'accordion-table-card';

            var titleEl = document.createElement('div');
            titleEl.className = 'accordion-table-card__title';
            titleEl.textContent = values[0] || '';
            card.appendChild(titleEl);

            var listEl = document.createElement('ul');
            listEl.className = 'accordion-table-card__list';

            var notesEl = null;

            // Bullet items for remaining columns.
            for (var i = 1; i < headers.length && i < values.length; i++) {
                var rawHeader = headers[i] || '';
                var headerLabel = cleanHeaderLabel(rawHeader) || rawHeader;

                var rawValue = values[i];
                var safeValue = rawValue && rawValue.length ? rawValue : '-';

                // If a header indicates notes, render as paragraph (not bullet).
                if (/notes/i.test(rawHeader)) {
                    if (!notesEl) {
                        notesEl = document.createElement('div');
                        notesEl.className = 'accordion-table-card__notes';
                    }

                    var notesLabel = headerLabel || 'Notes';
                    notesEl.textContent = notesLabel + ': ' + safeValue;
                    continue;
                }

                var li = document.createElement('li');
                li.className = 'accordion-table-card__list-item';
                li.textContent = headerLabel + ': ' + safeValue;
                listEl.appendChild(li);
            }

            if (listEl.children.length) card.appendChild(listEl);
            if (notesEl) card.appendChild(notesEl);

            cardsContainer.appendChild(card);
        });

        wrapper.parentNode.insertBefore(cardsContainer, wrapper.nextSibling);
        table.dataset.tableCardsBuilt = 'true';
    }

    function updateTableCardMode(root) {
        var tables = root.querySelectorAll('.accordion table');

        Array.prototype.forEach.call(tables, function (table) {
            var wrapper = getResponsiveWrapper(table);
            if (!wrapper) return;

            buildCardsForTable(root, table);

            var tableId = ensureId(table);
            var cardsContainer = findCardsContainer(root, tableId);
            if (!cardsContainer) return;

            if (isMobile()) {
                wrapper.style.display = 'none';
                cardsContainer.style.display = '';
            } else {
                wrapper.style.display = '';
                cardsContainer.style.display = 'none';
            }
        });
    }

    function setupFeesRoot(root) {
        if (!root || root.dataset.feesTableCardsInit === 'true') return;
        root.dataset.feesTableCardsInit = 'true';

        updateTableCardMode(root);

        if (mobileQuery.addEventListener) {
            mobileQuery.addEventListener('change', function () {
                updateTableCardMode(root);
            });
        } else if (mobileQuery.addListener) {
            mobileQuery.addListener(function () {
                updateTableCardMode(root);
            });
        }

        var observer = new MutationObserver(function () {
            updateTableCardMode(root);
        });
        observer.observe(root, { childList: true, subtree: true });
    }

    function scanRoots() {
        var roots = document.querySelectorAll('.fees-and-charges');
        Array.prototype.forEach.call(roots, function (root) {
            setupFeesRoot(root);
        });
    }

    // Initial + handle Matrix injections after load.
    if (document.readyState === 'loading') {
        window.addEventListener('DOMContentLoaded', scanRoots);
    } else {
        scanRoots();
    }

    var globalObserver = new MutationObserver(function () {
        scanRoots();
        scanExpandAll();
    });
    globalObserver.observe(document.documentElement, { childList: true, subtree: true });

    /**
     * Fees & Charges "Expand all" button handler.
     * Only applies inside `.fees-and-charges`.
     */
    function setupExpandAllButtons(root) {
        if (!root) return;

        var buttons = root.querySelectorAll('.fees-and-charges__expand-all');
        Array.prototype.forEach.call(buttons, function (btn) {
            if (!btn) return;
            // Some renderers (e.g. Matrix) may pre-set `data-expand-all-init="true"`.
            // We still want to bind our click/label logic in that case, so we use our own flag.
            if (btn.dataset.expandAllBound === 'true') return;
            btn.dataset.expandAllBound = 'true';

            function getAccordionForButton() {
                var targetSel = btn.getAttribute('data-expand-all-target') || '';
                var accordionRoot = null;

                if (targetSel) {
                    // Matrix may provide `#<numeric>` ids, which are not valid CSS selectors for querySelector.
                    // Use getElementById for `#id` style targets to avoid "not a valid selector" errors.
                    if (targetSel.charAt(0) === '#') {
                        var id = targetSel.slice(1);
                        // Matrix uses numeric `#100553` but the accordion container id is `accordion100553`.
                        accordionRoot = document.getElementById(id) || document.getElementById('accordion' + id);
                    } else {
                        accordionRoot = document.querySelector(targetSel);
                    }
                }

                if (accordionRoot) return accordionRoot;

                // Fallback: find the next accordion after this property header (per "separate instance" rendering).
                var headerEl = btn.closest('.fees-and-charges__property-header') || btn.parentElement;
                var node = headerEl;
                while (node && node.nextElementSibling) {
                    node = node.nextElementSibling;
                    if (node.classList && node.classList.contains('accordion')) return node;
                    if (node.classList && node.classList.contains('fees-and-charges__property-header')) break;
                }

                return root.querySelector('.accordion');
            }

            function refreshButtonLabel() {
                var accordionRoot = getAccordionForButton();
                if (!accordionRoot) return;

                var collapses = accordionRoot.querySelectorAll('.collapse');
                if (!collapses || !collapses.length) return;

                var hasAnyOpen = false;
                Array.prototype.forEach.call(collapses, function (el) {
                    if (el.classList.contains('show')) hasAnyOpen = true;
                });

                var labelEl = btn.querySelector('span');
                if (labelEl) {
                    labelEl.textContent = hasAnyOpen ? 'Collapse all' : 'Expand all';
                }
            }

            function ensureMultiOpenForThisAccordion() {
                // Remove the Bootstrap "one open at a time" constraint only for the accordion controlled by this button.
                if (btn.dataset.accordionMultiOpenInit === 'true') return;
                var accordionRoot = getAccordionForButton();
                if (!accordionRoot) return;

                var collapsesForAccordion = accordionRoot.querySelectorAll('.collapse');
                Array.prototype.forEach.call(collapsesForAccordion, function (el) {
                    if (el && el.hasAttribute('data-parent')) el.removeAttribute('data-parent');
                });
                btn.dataset.accordionMultiOpenInit = 'true';
            }

            btn.addEventListener('click', function () {
                ensureMultiOpenForThisAccordion();

                var accordionRoot = getAccordionForButton();
                if (!accordionRoot) return;

                var collapses = accordionRoot.querySelectorAll('.collapse');
                if (!collapses || !collapses.length) return;

                // Button state is based on whether at least one panel is open:
                // - if any are open => click should COLLAPSE all
                // - if none are open => click should EXPAND all
                var hasAnyOpen = false;
                Array.prototype.forEach.call(collapses, function (el) {
                    if (el.classList.contains('show')) hasAnyOpen = true;
                });
                var shouldExpand = !hasAnyOpen;

                Array.prototype.forEach.call(collapses, function (el) {
                    if (window.$ && typeof window.$(el).collapse === 'function') {
                        window.$(el).collapse(shouldExpand ? 'show' : 'hide');
                    } else {
                        el.classList.toggle('show', shouldExpand);
                        el.style.display = shouldExpand ? '' : 'none';
                    }
                });

                var headerBtns = accordionRoot.querySelectorAll('.card-header button');
                Array.prototype.forEach.call(headerBtns, function (b) {
                    b.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
                    if (shouldExpand) {
                        b.classList.remove('collapsed');
                    } else {
                        b.classList.add('collapsed');
                    }
                });

                refreshButtonLabel();
            });

            // Keep label in sync when the user manually opens/closes a single panel.
            // We treat "any panel open" as the "Collapse all" state.
            var accordionRoot = getAccordionForButton();
            if (accordionRoot) {
                var collapses = accordionRoot.querySelectorAll('.collapse');
                Array.prototype.forEach.call(collapses, function (el) {
                    if (window.$ && typeof window.$(el).on === 'function') {
                        window.$(el).on('shown.bs.collapse', refreshButtonLabel);
                        window.$(el).on('hidden.bs.collapse', refreshButtonLabel);
                    }
                });

                // Fallback for environments without the Bootstrap/jQuery event wiring.
                var mo = new MutationObserver(function () {
                    refreshButtonLabel();
                });
                mo.observe(accordionRoot, {
                    attributes: true,
                    attributeFilter: ['class', 'style', 'aria-expanded'],
                    subtree: true
                });
            }

            ensureMultiOpenForThisAccordion();
            refreshButtonLabel();
        });
    }

    // Attach handler for any existing/new Fees & Charges section.
    function scanExpandAll() {
        var roots = document.querySelectorAll('.fees-and-charges');
        Array.prototype.forEach.call(roots, function (root) {
            setupExpandAllButtons(root);
        });
    }

    scanExpandAll();
}());

